// Local Imports
import { graphics, model } from "GenAlphaModel";
import { MousePos } from "../../../mousepos";
import * as style from "../../../style";
import { Base } from "./base";
import { DrawTo } from "../../../draw";

//
// # Unresolved Instance Data
//
// Bounding box is required.
// This is (we think) the same as `Required<InstanceData>`,
// but made to explicitly be about the `bbox` field.
//
type Data = Omit<model.Instance, "bbox"> & { bbox: model.Bbox };

// # Unresolved Instance
//
export class UnresolvedInstance extends Base<Data> {
  static readonly instanceKind = "unresolved" as const;
  override readonly cache = this.makeCache<style.ShapeStyle>(table);
  get style(): style.ShapeStyle {
    return this.cache.style;
  }

  // Draw the familiar "box and cross". SAD!
  override redraw = (to: DrawTo) => {
    const { bbox } = this.data;
    to.bbox(bbox, this.style);
    let points = [this.data.bbox.min, this.data.bbox.max];
    to.path(graphics.Path.fromPartial({ points }), this.style);
    // Create the other half of the bbox cross,
    points = [
      { x: bbox.min.x, y: bbox.max.y },
      { x: bbox.max.x, y: bbox.min.y },
    ];
    to.path(graphics.Path.fromPartial({ points }), this.style);

    return null;
  };

  // Boolean indication of whether `mousePos` is inside the Instance's bounding box.
  // Test against all of the Instance's `SelectionBox`es.
  hitTest = (mousePos: MousePos): boolean => {
    return model.Bbox.contains(this.data.bbox, mousePos.sch);
  };

  // Box-drag selection: the unresolved-instance bbox is its only selection region.
  intersectsBbox = (bbox: model.Bbox): boolean => {
    return model.Bbox.intersects(bbox, this.data.bbox);
  };
}

const { red, yellow } = style.Color;

// Unresolved instance "error box" style
export const table: style.ShapeStyleTable = {
  //       light light    dark  dark
  //       no    hilited  no    hilited
  fill: style.Special.None,
  stroke: { light: red, dark: yellow },
  linewidth: 2,
  cap: "round",
  join: "round",
};
